import { ErrorMessage } from 'formik';
import moment from 'moment';
import React, { Component } from 'react';
import centralDoacaoService from 'services/centralDoacaoService';
import estoqueService from 'services/estoqueService';
import UploadBrowseFile from '../../../components/BrowseFile/uploadBrowseFile.component';
import Input from '../../../components/Input/input.component';
import { numberMask } from '../../../components/Input/Masks';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';
import Required from '../../../components/Required/required.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import UploadService from '../../../services/uploadService';
import DateHelper from '../../../utils/dateHelper';
import { SaidaValidationSchemaEdit } from './modal.validate';

export default class EditarModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			saida: {
				dataSaida: '',
				quantidade: '',
				statusOficio: '',
				termoRecebimento: '',
				tipoSaida: '',
				ocorrenciaDestino: null,
				oficioDestino: null,
			},
			files: [],
			oficios: [],
			eventos: [],
			termoRemovidoManualmente: false,
		};
	}

	async componentDidMount() {
		const allOficios = await centralDoacaoService.findOficiosAtivosSemPaginacao();
		this.setState({
			oficios: [...allOficios.data],
		});
		const allEventos = await estoqueService.findAllOcorrencias();
		this.setState({
			eventos: [...allEventos.data],
		});

		const { transacao } = this.props;

		if (transacao.oficioDestino && transacao.oficioDestino.status.codigo === 'ATENDIDO') {
			this.setState({
				oficios: [...allOficios.data, transacao.oficioDestino],
			});
		}

		/* Populando o estado com os dados do item editável */
		this.setState(prevState => ({
			saida: {
				...prevState.saida,
				...transacao,
				tipoSaida: transacao.ocorrenciaDestino ? 'evento' : 'oficio',
				statusOficio: transacao.oficioDestino ? transacao.oficioDestino.status.codigo : null,
				dataSaida: moment(transacao.dataSaidaLong).format('YYYY-MM-DD'),
			},
			files: [{
				source: 1,
				options: {
					type: 'limbo',
					file: {
						name: transacao.termoRecebimento ? transacao.termoRecebimento.nome : '',
						size: transacao.termoRecebimento ? transacao.termoRecebimento.size : 0,
					},
				},
			}],
		}));
	}

	onChangeOficio(item) {
		const newState = this.state;
		newState.saida.oficioDestino = item.object;
		newState.saida.oficioId = item.object.id;
		newState.saida.oficioDestino.status.codigo = newState.saida.statusOficio;
		this.setState(newState);
	}

	onChangeEvento(item) {
		const newState = this.state;
		newState.saida.ocorrenciaDestino = item.object;
		newState.saida.ocorrenciaId = item.object.id;
		this.setState(newState);
	}

	onChangeTipoSaida(event) {
		const { transacao } = this.props;
		const newState = this.state;
		newState.saida.tipoSaida = event.target.value;

		if (!newState.termoRemovidoManualmente) {
			newState.files = [{
				source: 1,
				options: {
					type: 'limbo',
					file: {
						name: transacao.termoRecebimento ? transacao.termoRecebimento.nome : '',
						size: transacao.termoRecebimento ? transacao.termoRecebimento.size : 0,
					},
				},
			}];
		}
		this.setState(newState);
	}

	handlePosUploadAction = (termoRecebimento, valuesFormik) => {
		this.setState({
			saida: {
				...valuesFormik,
				termoRecebimento: termoRecebimento.data.data,
			},
		});
	};

	handleRemoveFile = () => {
		this.setState(prevState => ({
			files: [],
			saida: {
				...prevState.saida,
				termoRecebimento: '',
			},
			termoRemovidoManualmente: true,
		}));
	};

	render() {
		const {
			props: {
				isOpenEditar,
				handleCloseEdit,
				handleSubmitEdit,
				nomeItem,
			},
			state: {
				saida,
				files,
				oficios,
				eventos,
			},
		} = this;

		return (
			<WidgetModalForm
				textCancelar='Cancelar'
				textConfirmar='Salvar'
				title='Editar saída'
				initialValues={saida}
				validationSchema={SaidaValidationSchemaEdit}
				confirmar={handleSubmitEdit}
				isOpen={isOpenEditar}
				cancelar={handleCloseEdit}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo='Atenção!'
				modalConfirmarCancelarCorpo='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos.'
				iconCancelar='fas fa-times'
				iconConfirmar='fas fa-save'
				tamanho='lg'
			>
				<ModalFormContext.Consumer>
					{({
						values, handleChange, resetForm, validateForm,
					}) => (
						<React.Fragment>
							<div>
								<p><strong>Item:</strong> {nomeItem} </p>
							</div>
							<div className='row'>
								<div className='col-md-12'>
									<label>
									A retirada é para ofício ou para atender ocorrência? <Required />
									</label>
									<div className='form-group'>
										<div className='form-check form-check-inline'>
											<Input
												id='radio_1'
												name='tipoSaida'
												type='radio'
												className='form-check-input'
												value='oficio'
												onChange={(value) => {
													handleChange(value);
													this.onChangeTipoSaida(value);
													resetForm();
												}}
												checked={saida.tipoSaida === 'oficio'}
											/>
											<label
												htmlFor='radio_1'
												className='form-check-label pointer-text'
											>
												Ofício
											</label>
										</div>

										<div className='form-check form-check-inline'>
											<Input
												id='radio_2'
												name='tipoSaida'
												type='radio'
												value='evento'
												className='form-check-input'
												onChange={(value) => {
													handleChange(value);
													this.onChangeTipoSaida(value);
													resetForm();
												}}
												checked={saida.tipoSaida === 'evento'}
											/>
											<label
												htmlFor='radio_2'
												className='form-check-label pointer-text'
											>
												Ocorrência
											</label>
										</div>
									</div> {/* .form-group */}
								</div> {/* .col-md-12 */}
								<ErrorMessage
									name='tipoSaida'
									render={msg => (
										<span className='ml-3 text-danger'>
											{msg}
										</span>
									)}
								/>
							</div> {/* .row */}

							{/* SAÍDA DO TIPO OFICIO */}
							{saida.tipoSaida === 'oficio'
								&& (
									<React.Fragment>
										<div className='row'>
											<div className='col-md-12'>
												<label>
													Ofício:
													{' '}
													<Required />
												</label>
												<div className='form-group'>
													<SelectMulti
														isSearchable
														isClearable={false}
														isMulti={false}
														name='oficio'
														label='nomeOficio'
														value={values.oficioDestino}
														onChange={(item) => {
															this.onChangeOficio(
																item,
															);
															validateForm();
														}}
														options={oficios}
													/>
													<ErrorMessage
														name='oficioDestino'
														render={msg => (
															<span className='text-danger'>
																{msg}
															</span>
														)}
													/>
												</div> {/* .form-group */}
											</div> {/* .col-md-12 */}
										</div> {/* row */}

										<div className='row'>
											<div className='col-md-6'>
												<label>
													Quantidade:
													{' '}
													<Required />
												</label>
												<Input
													type='text'
													mask={numberMask}
													name='quantidade'
													value={values.quantidade}
													onChange={handleChange}
												/>
												<ErrorMessage
													name='quantidade'
													render={msg => (
														<span className='text-danger'>
															{msg}
														</span>
													)}
												/>
											</div>
											<div className='col-md-6'>
												<label>
													Data:
													{' '}
													<Required />
												</label>
												<Input
													type='date'
													name='dataSaida'
													max={DateHelper.isoDate(new Date())}
													value={values.dataSaida}
													onChange={handleChange}
												/>
												<ErrorMessage
													name='dataSaida'
													render={msg => (
														<span className='text-danger'>
															{msg}
														</span>
													)}
												/>
											</div>

										</div>
										<div className='row mt-1'>
											<div className='col-md-12'>
												<div>
													<label>
														O ofício foi atendido totalmente ou parcialmente: <Required />
													</label>
												</div>
												<div className='form-group'>
													<div className='form-check form-check-inline'>
														<Input
															id='radio_3'
															name='statusOficio'
															type='radio'
															className='form-check-input'
															onChange={(e) => {
																handleChange(e);
																this.setState(() => ({
																	saida: {
																		...values,
																		statusOficio: 'ATENDIDO',
																	},
																}));
															}}
															checked={values.statusOficio === 'ATENDIDO'}
														/>
														<label
															htmlFor='radio_3'
															className='form-check-label pointer-text'
														>
															Totalmente
														</label>
													</div>

													<div className='form-check form-check-inline'>
														<Input
															id='radio_4'
															name='statusOficio'
															type='radio'
															className='form-check-input'
															onChange={(e) => {
																handleChange(e);
																this.setState(() => ({
																	saida: {
																		...values,
																		statusOficio: 'PARCIALMENTE_ATENDIDO',
																	},
																}));
															}}
															checked={values.statusOficio === 'PARCIALMENTE_ATENDIDO'}
														/>
														<label
															htmlFor='radio_4'
															className='form-check-label pointer-text'
														>
															Parcialmente
														</label>
													</div>
												</div>
											</div>
											<ErrorMessage
												name='statusOficio'
												render={msg => (
													<span className='ml-3 text-danger'>
														{msg}
													</span>
												)}
											/>
										</div>

										<div className='row'>
											<div className='col-md-12'>
												<label>
													Anexar termo de recebimento: <Required />
												</label>
											</div>
											<div className='container'>
												<UploadBrowseFile
													name='termoRecebimento'
													files={files}
													context={this}
													aspectRatio={0.1}
													valuesFormik={values}
													expetedTypesLabel='Selecione arquivos de texto ou imagens'
													onUpload={this.handlePosUploadAction}
													handleUploadFile={UploadService.handleUploadFilePond}
													acceptedFileTypes={
														[
															'application/pdf',
															'application/msword',
															'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
															'image/png',
															'image/jpeg',
															'image/jpg',
															'image/bmp',
															'image/tiff',
														]
													}
													handleRemoveFile={this.handleRemoveFile}
												/>
												<ErrorMessage
													name='termoRecebimento'
													render={msg => (
														<span className='text-danger'>
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</React.Fragment>
								)
							}

							{/* SAIDA DO TIPO EVENTO/OCORRÊNCIA */}
							{saida.tipoSaida === 'evento'
								&& (
									<React.Fragment>
										<div className='row'>
											<div className='col-md-12'>
												<label>
													Ocorrência:
													{' '}
													<Required />
												</label>
												<div className='form-group'>
													<SelectMulti
														isSearchable
														isClearable={false}
														isMulti={false}
														name='evento'
														label='nome'
														value={values.ocorrenciaDestino}
														onChange={(item) => {
															this.onChangeEvento(
																item,
															);
															validateForm();
														}}
														options={eventos}
													/>
													<ErrorMessage
														name='ocorrenciaDestino'
														render={msg => (
															<span className='text-danger'>
																{msg}
															</span>
														)}
													/>
												</div> {/* .form-group */}
											</div> {/* .col-md-12 */}
										</div> {/* row */}

										{/*
											Condicional para saber se algum evento/ocorrência foi selecionado
										*/}
										{values.ocorrenciaDestino !== null
											&& (
												<div>
													<div className='row'>
														<div className='col-md-6'>
															<label><strong>Município:</strong></label>
															<p>{values.ocorrenciaDestino.municipio.nome}</p>
														</div>
														<div className='col-md-6'>
															<label><strong>Data do evento:</strong></label>
															<p>{values.ocorrenciaDestino.data}</p>
														</div>
													</div>
												</div>
											)
										}

										<div className='row'>
											<div className='col-md-6'>
												<label>
													Quantidade:
													{' '}
													<Required />
												</label>
												<Input
													name='quantidade'
													type='text'
													mask={numberMask}
													value={values.quantidade}
													onChange={handleChange}
												/>
												<ErrorMessage
													name='quantidade'
													render={msg => (
														<span className='text-danger'>
															{msg}
														</span>
													)}
												/>
											</div>

											<div className='col-md-6'>
												<label>
													Data:
													{' '}
													<Required />
												</label>
												<Input
													type='date'
													name='dataSaida'
													max={DateHelper.isoDate(new Date())}
													value={values.dataSaida}
													onChange={handleChange}
												/>
												<ErrorMessage
													name='dataSaida'
													render={msg => (
														<span className='text-danger'>
															{msg}
														</span>
													)}
												/>
											</div>
										</div>


										{/* UPLOAD SEÇÃO EVENTOS/OCORRÊNCIA */}
										<div className='row'>
											<div className='col-md-12'>
												<label>
													Anexar termo de recebimento: <Required />
												</label>
											</div>
											<div className='container'>
												<UploadBrowseFile
													name='termoRecebimento'
													files={files}
													context={this}
													valuesFormik={values}
													aspectRatio={0.1}
													expetedTypesLabel='Selecione arquivos de texto ou imagens'
													onUpload={this.handlePosUploadAction}
													handleUploadFile={UploadService.handleUploadFilePond}
													acceptedFileTypes={
														[
															'application/pdf',
															'application/msword',
															'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
															'image/png',
															'image/jpeg',
															'image/jpg',
															'image/bmp',
															'image/tiff',
														]
													}
													handleRemoveFile={this.handleRemoveFile}
												/>
												<ErrorMessage
													name='termoRecebimento'
													render={msg => (
														<span className='text-danger'>
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</React.Fragment>
								)
							}
						</React.Fragment>
					)}
				</ModalFormContext.Consumer>

			</WidgetModalForm>
		);
	}
}
